<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-star-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.278 38.979l-10.695 5.144a1.667 1.667 0 01-2.38-1.675L11.417 30.8A1.667 1.667 0 0011 29.513l-7.898-8.787a1.667 1.667 0 01.891-2.744l11.555-2.466a1.667 1.667 0 001.095-.795l5.915-10.227a1.667 1.667 0 012.886 0l5.915 10.227c.236.408.634.697 1.095.795l11.555 2.466a1.667 1.667 0 01.891 2.744l-7.898 8.787c-.315.35-.467.818-.418 1.287l1.214 11.648a1.667 1.667 0 01-2.38 1.675l-10.695-5.144a1.667 1.667 0 00-1.444 0z"/></svg>
</template>
<script>

export default {
  name: 'IconStarFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
